// Loaded in Node by vite.ts from vite.config.ts: keep it free of imports.

export type Env = Readonly<Partial<Record<string, string>>>;

/** Container variables with this prefix get into config.js, without it. */
export const ENV_PREFIX = 'APP_';

/** Anything but an object of strings means no settings. */
export function readEnv(value: unknown): Env {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    return {};
  }

  const entries = Object.entries(value);
  return entries.every(([, item]) => typeof item === 'string')
    ? Object.fromEntries(entries)
    : {};
}

/** `{ APP_STAND: 'dev' }` → `window.__APP_CONFIG__ = {"STAND":"dev"};`, as docker/40-runtime-config.sh writes it. */
export function toConfigScript(
  variables: Readonly<Record<string, string | undefined>>
): string {
  const config = Object.fromEntries(
    Object.entries(variables)
      .filter(
        (entry): entry is [string, string] =>
          entry[0].startsWith(ENV_PREFIX) && entry[1] !== undefined
      )
      .map(([name, value]) => [name.slice(ENV_PREFIX.length), value])
      .sort(([a], [b]) => a.localeCompare(b))
  );

  return `window.__APP_CONFIG__ = ${JSON.stringify(config)};\n`;
}
